export default "_next/static/rdkit.0acad34ed2ae63ff4400a4e1e08ab369.wasm";